function NoListDataAvailable({ type }) { 
    return ( 
        <>
            <tr>
                <td colSpan="12" style={{ textAlign: 'center', padding: '10px' }}>
                    {/* <div className={`${type}-no-data`}> */}
                     {/* className={`div-no-data`} */}
                    <div>
                    No {type} available 
                    </div>
                </td>
            </tr> 
        </>
    ); 
} 
export default NoListDataAvailable;